import React from 'react';
import Icon from '@ant-design/icons';
import OpenOutIcon from '@icons/common/open-out.svg';
import { Button, Tooltip } from 'antd';

function Drilldown({ createDashboard, disabled = false }) {
  return (
    <Tooltip placement="top" title="Open a temporary dashboard to analyze">
      <Button
        disabled={disabled}
        size="small"
        icon={<Icon component={OpenOutIcon} />}
        type="text"
        onClick={createDashboard}
      />
    </Tooltip>
  );
}

export default Drilldown;
